import { FC, useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../system/providers/appContextProvider";
import GridMultipleSelectorInputV2 from "../../../components/controls/GridMultipleSelectorInputV2";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import useGridFilter from "../../../system/hooks/useGridFilter";
import { LabelDesignerTemplateDataProvider } from "../../../Services/DataProviders/LabelDesignerTemplateDataProvider";
import { ILabelPrintScenarioDTO, ILabelPrintScenarioItemViewDTO } from "../../../libs/coreapi-dto/dirs/labelPrintScenario";
import { LabelDesignerTemplateGridPluginSettings } from "../LabelDesignerTemplate/LabelDesignerTemplateGridPluginSettings";
import { LabelDesignerTemplateMultiSelectorModal } from "../LabelDesignerTemplate/LabelDesignerTemplateMultiSelectorModal";

interface ISourceTypeEditModalProps {
    data: ILabelPrintScenarioDTO
    setData: (value: Array<IEntitySimpleDTO>) => void
    lockFromPermission?: boolean
}

export enum FieldsSourceTypes {
    SourceTypes = "SourceTypes",
    IsActive = 'IsActive'
}

const DefaultGridFilter: IGridFilter = {
    numberPerPage: 15,
    pageNumber: 1,
    columnFilters: [
        {
            name: "Name",
            operator: 'More',
            value: 0
        }
    ],
};

export const LabelScenarioItemEdit: FC<ISourceTypeEditModalProps> = (props) => {
    const appContext = useAppContext()
    const [sourceTypesItems, setSourceTypesItems] = useState<ILabelPrintScenarioItemViewDTO[]>([]);
    const [gridFilter, dispatchGridFilter] = useGridFilter(DefaultGridFilter);
    const [gridFilterItems, dispatchGridFilterItems] = useGridFilter(DefaultGridFilter);
    const [totalCount, setTotalCount] = useState(0);
    const dataProvider = new LabelDesignerTemplateDataProvider(appContext.coreApiService);

    // Локализация
    const { t } = useTranslation();
    const baseT = (value: string) => t("directory.labelDesignerTemplate." + value);

    useEffect(() => {
        // componentDidMount events
        getSourceTypesItems(props.data.items, props.data)

        return () => {
            // componentWillUnmount events
        }
    }, [])

    function getSourceTypesItems(entities: IEntitySimpleDTO[], data?: ILabelPrintScenarioDTO) {
        if (!data)
            return;
        dataProvider.getView(gridFilterItems, (values, count) => {
            let filterValues = values.filter(x => entities.find(y => y.idGlobal === x.idGlobal));
            filterValues = filterValues.filter((ele, ind) => ind === filterValues.findIndex(elem => elem.name === ele.name));
            setSourceTypesItems(filterValues)
            setTotalCount(filterValues.length);
            props.setData(filterValues.map((x) => {
                return {
                    displayName: x.displayName,
                    idGlobal: x.idGlobal
                } as IEntitySimpleDTO
            }))
        })
    }

    function updateSourceTypeItems(entities: IEntitySimpleDTO[]) {
        getSourceTypesItems(entities, props.data);
    }

    return <>
        <GridMultipleSelectorInputV2
            selectedEntity={sourceTypesItems?.[0]}
            selectedEntities={sourceTypesItems}
            id={`id-${uuidv4()}`}
            switchOnchange
            gridFilter={gridFilter}
            selectorModalJsx={LabelDesignerTemplateMultiSelectorModal}
            label={baseT("title")}
            onSelect={(entities: IEntitySimpleDTO[]) => {
                updateSourceTypeItems(entities);
            }}
            disabled={props.lockFromPermission}
        />
        <DefaultGrid
            gridId={uuidv4()}
            data={sourceTypesItems}
            filter={gridFilterItems}
            totalCount={totalCount}
            plugin={LabelDesignerTemplateGridPluginSettings}
            selectedItem={undefined}
            onSelect={(row) => { }}
            onSort={(i) => { }}
            onFilterDelete={(i) => { dispatchGridFilterItems({ type: "deleteColumnFilter", payload: i.propertyName }) }}
            onPageNumberChange={(n) => { dispatchGridFilterItems({ type: "changePageNumber", payload: { pageNumber: n } }) }}
            onNumberPerPageChange={(n) => { dispatchGridFilterItems({ type: "changeNumberPerPage", payload: { numberPerPage: n } }) }}
            hiddenPagination={undefined}
        />
    </>
}